import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/blogs/slug/${slug}`).then(({data})=>setBlog(data)).catch(()=>setError("Article not found"));
  }, [slug]);

  if (error) return (
    <main className="pt-32 pb-16 container-x">
      <p className="text-slate-600">{error}</p>
      <Link to="/blog" className="btn-primary mt-4">Back to Blog</Link>
    </main>
  );

  if (!blog) return <main className="pt-32 pb-16 container-x">Loading…</main>;

  return (
    <main className="pt-32 pb-16" data-testid="blog-detail-page">
      <div className="container-x max-w-3xl">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-primary"><ArrowLeft className="w-4 h-4"/> Back to Blog</Link>
        <span className="overline block mt-6">{blog.category}</span>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight font-light mt-3">{blog.title}</h1>
        <div className="text-sm text-slate-500 mt-2">{(blog.created_at||"").slice(0,10)}</div>
        {blog.cover_url && <img src={blog.cover_url} alt={blog.title} className="mt-8 rounded-2xl w-full"/>}
        <div className="prose prose-slate mt-8 max-w-none whitespace-pre-wrap text-slate-700 leading-relaxed">{blog.content}</div>
      </div>
    </main>
  );
}
